import Page from './js/Page'
import {
  educationAnimationTimeline,
  homeAnimationTimline,
  workAnimationTimeline,
  educationAnimationTimelineMobile,
  homeAnimationTimlineMobile,
  workAnimationTimelineMobile,
  contactmeAnimationTimeline,
  contactmeAnimationTimelineMobile,
  flyAnimation,
} from './js/timelines'
import Router from './js/Router'
import Pristine from 'pristinejs'
import qs from 'query-string'

export const isMobileDevice = () => window.innerWidth < 700

// SCREEN TO PAGE OBEJCT MAPPING
const getDesktopPageMapping = (): screenToPageObjectInterface =>
  <screenToPageObjectInterface>{
    home: new Page('home', homeAnimationTimline()),
    work: new Page('work', workAnimationTimeline()),
    aboutme: new Page('aboutme', educationAnimationTimeline()),
    contactme: new Page('contactme', contactmeAnimationTimeline()),
  }

const getMobilePageMapping = (): screenToPageObjectInterface =>
  <screenToPageObjectInterface>{
    home: new Page('home', homeAnimationTimlineMobile()),
    work: new Page('work', workAnimationTimelineMobile()),
    aboutme: new Page('aboutme', educationAnimationTimelineMobile()),
    contactme: new Page('contactme', contactmeAnimationTimelineMobile()),
  }

const createWindowResizeHandler = (currentWindowWidth: number) => {
  let mode = currentWindowWidth < 700 ? 'mobile' : 'desktop'
  const handleWindowResize = (router: Router) => {
    const currentWindowWidth = window.innerWidth

    // DO NOTHING IF THERE IS NO CHANGE IN DISPLAY MODE
    if (
      (mode == 'mobile' && currentWindowWidth < 700) ||
      (mode == 'desktop' && currentWindowWidth > 700)
    )
      return

    mode = currentWindowWidth < 700 ? 'mobile' : 'desktop'
    const mapping: screenToPageObjectInterface =
      mode == 'mobile' ? getMobilePageMapping() : getDesktopPageMapping()
    router.setMappings(mapping)
    router.handleInitialRender()
  }
  return handleWindowResize
}

// AFTER DOM RENDER
window.addEventListener('DOMContentLoaded', function () {
  // INITIALIZATION OF THE ROUTER
  // TODO: Use Router Props on perform actions on route change
  const router = new Router(
    window.innerWidth < 700 ? getMobilePageMapping() : getDesktopPageMapping(),
    {
      onEnter: () => {
        document
          .querySelectorAll('.loader-container')
          .forEach((el) => el.classList.add('show'))
        document.querySelector('.navigation-wrapper').classList.add('no-click')
      },
      onExit: () => {
        document
          .querySelectorAll('.loader-container')
          .forEach((el) => el.classList.remove('show'))
        document
          .querySelector('.navigation-wrapper')
          .classList.remove('no-click')
      },
    }
  )
  // ReInitialize the router with new animation timelines in case of window resize for compatibility with mobile devices
  const handleWindowResize = createWindowResizeHandler(window.innerWidth)
  window.addEventListener('resize', () => handleWindowResize(router))

  setTimeout(() => {
    router.handleInitialRender()
  }, 400)

  // ADDING FULSCREEN ACCESS ON USER BUTTON CLICK
  const fullScreenButton = document.querySelector('#fullscreenbtn')
  fullScreenButton.addEventListener('click', () => {
    const mainWrapper = document.querySelector('.main-wrapper')
    if (mainWrapper.classList.contains('fullscreen')) {
      document.exitFullscreen()
      mainWrapper.classList.remove('fullscreen')
      return
    }
    mainWrapper.classList.add('fullscreen')
    mainWrapper.requestFullscreen()
  })

  // ADDING NAV LINK AND POPSTATE LISTNERS
  document.querySelectorAll('.nav-button, .nav-link').forEach((el) => {
    el.addEventListener('click', router.to)
  })
  window.addEventListener('popstate', router.handlePopState)

  // FLYING PLANE ANIMATION FOR THE CONTACT FORM SEND BUTTON
  document
    .querySelector('.contact-form button')
    .addEventListener('mouseenter', (e) => {
      const planeEl = (e.target as HTMLElement).querySelector('span')
      flyAnimation(planeEl)
    })

  // Submitting the Contact Form using AJAX
  const contactFormEl = document.querySelector('[name=contact-form]')
  const contactFormValidator = new Pristine(
    contactFormEl,
    {
      classTo: 'input-group',
      errorClass: 'has-danger',
      successClass: 'has-success',
      errorTextParent: 'input-group',
      errorTextTag: 'span',
      errorTextClass: 'text-help',
    },
    true
  )

  contactFormEl.addEventListener('submit', async function (e) {
    e.preventDefault()
    if (!contactFormValidator.validate()) return
    let formValues = getFormData(this)
    formValues['form-name'] = getFormName(this)
    await fetch('/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: qs.stringify(formValues),
    })
    {
      ;(<HTMLFormElement>this).reset()
    }
    alert('Thanks, You will hear from me soon 😃')
  })
})

const getFormData = (formEl: HTMLFormElement) => {
  const formData = new FormData(formEl)
  const formKeyIterator = formData.keys()
  let done = false
  let formValues = {}
  while (!done) {
    const { done: finish, value: key } = formKeyIterator.next()
    done = finish
    if (key) {
      formValues[key] = formData.get(key)
    }
  }
  return formValues
}

const getFormName = (formEl: HTMLFormElement) =>
  formEl.attributes.getNamedItem('name').value
